module.exports = __webpack_public_path__ + "assets/img/ic-intro-bag.489dc20e.png";